import React, { createContext, useContext, useState } from 'react';
import type { Language } from '@/types';
import { savedLanguage } from '@/lib/language';

interface LanguageContextType {
  language: Language;
  toggleLanguage: () => void;
  switchToLanguage: (lang: Language) => void;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const useLanguage = (): LanguageContextType => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }: React.PropsWithChildren) => {
  const [language, setLanguage] = useState<Language>(savedLanguage);

  const toggleLanguage = () => {
    const newLang: Language = language === 'tr' ? 'en' : 'tr';
    setLanguage(newLang);
    localStorage.setItem('delay24_language', newLang);
  };

  const switchToLanguage = (lang: Language) => {
    setLanguage(lang);
    localStorage.setItem('delay24_language', lang);
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, switchToLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
